<ng-container *ngIf="containsCheckControl; then controlCheck else controlRegular"></ng-container>

<ng-template #controlCheck>
  <div class="form-check">
    <ng-container *ngTemplateOutlet="projection"></ng-container>
    <label [for]="id" class="form-check-label">{{label}}</label>
  </div>
</ng-template>

<ng-template #controlRegular>
  <ng-container *ngIf="isHorizontal; then horizontal else vertical"></ng-container>
</ng-template>


<ng-template #horizontal>
  <div [ngClass]="orientationConfig.label" class="col-form-label"><label [for]="id">{{label}}</label></div>
  <div [ngClass]="orientationConfig.control">
    <ng-container *ngTemplateOutlet="projection"></ng-container>
  </div>
</ng-template>

<ng-template #vertical>
  <label [for]="id" class="form-label">{{label}}</label>
  <ng-container *ngTemplateOutlet="projection"></ng-container>
</ng-template>

<ng-template #projection>
  <ng-content></ng-content>
</ng-template>
